module.exports = __webpack_public_path__ + "img/security.6f361a34.png";